import React from 'react';
import {observer} from "mobx-react";
import {PropositionBetsWidgetBet} from "./proposition-bets-widget.bet";

export const PropositionBetsWidgetBets = observer(({controller, isPreview}) => {
  const {state} = controller;
  const {bets, previewBets} = state;

  const currentBets = isPreview ? previewBets : bets
  return currentBets?.map((bet, index) => {
    const betProps = {
      isOpen: index === 0,
      controller,
      isPreview,
      bet
    }

    return <PropositionBetsWidgetBet {...betProps} key={bet.id}/>
  })
});
